export default {
    components: {
        "mhi-checkbox": () =>
            import(
                /* webpackChunkName: "CheckboxInput" */
                "@/components/input/CheckboxInput.vue"
            ),
        "mhi-date": () =>
            import(
                /* webpackChunkName: "DateInput" */
                "@/components/input/DateInput.vue"
            ),
        "mhi-radio": () =>
            import(
                /* webpackChunkName: "RadioInput" */
                "@/components/input/RadioInput.vue"
            ),
        "mhi-select": () =>
            import(
                /* webpackChunkName: "SelectInput" */
                "@/components/input/SelectInput.vue"
            ),
        "mhi-text": () =>
            import(
                /* webpackChunkName: "TextInput" */
                "@/components/input/TextInput.vue"
            ),
        "mhi-listadd": () =>
            import(
                /* webpackChunkName: "ListAddInput" */
                "@/components/input/ListAddInput.vue"
            ),
        "mhi-combobox": () =>
            import(
                /* webpackChunkName: "ComboBox" */
                "@/components/input/ComboBox.vue"
            ),
    },
};
